module.exports = __webpack_public_path__ + "img/maestrocard.d68a915c.svg";